var map = {
	"./1.webp": 4597,
	"./2.webp": 3848,
	"./3.webp": 3019,
	"./4.webp": 4662,
	"./5.webp": 9393,
	"./6.webp": 2052,
	"./7.webp": 3911
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6038;